// Resolve the filename stored in the catalog, without category-name overrides.
const catalogImages = require.context('@/assets/images/markets', true, /\.(?:png|jpe?g|webp|svg)$/i);
const imagePaths = catalogImages.keys();

export function resolveMarketImage(value) {
  if (typeof value !== 'string' || !value.trim()) return '';
  const filename = value.trim().replace(/\\/g, '/').replace(/^\.\//, '');
  let path = './' + filename;
  if (!imagePaths.includes(path)) {
    const matches = imagePaths.filter(item => item.split('/').pop() === filename);
    if (matches.length !== 1) return '';
    path = matches[0];
  }
  const image = catalogImages(path);
  return image.default || image;
}

export function getMarketImage(details) {
  return resolveMarketImage(details.educationImage);
}
